import React, { useEffect, useState } from "react";
import { ModalAlignmentEnum } from "@voltmoney/types";
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, DividerSizeTokens, IconSizeTokens, IconTokens, InputStateToken, TextAlignTokens, TypographyTypeDLS, } from "@voltmoney/schema";
import { Dimensions, Image, Platform, TouchableOpacity, View } from "react-native";
import CustomHeader from "../../customHeader/CustomHeader";
import { ListItem } from "../../listItem/ListItem";
import { Typography } from "../../typography/Typography";
import { Divider } from "../../divider/Divider";
import NeedHelpDC from "../NeedHelpDC";
import BoilerPlate from "../boilerPlate/BoilerPlate";
import { isMobile } from "../../stack/utils";
import Icon from "../../icon/Icon";
import ButtonDLSBase from "../../button/ButtonDLS.base";
import BottomSheet from "../BottomSheet";
import { getScreenType } from "../utils";
import OtpModalScreenDc from "../OtpModalScreenDc";
import { UPDATE_REQUEST_TYPE } from "../constants";
const AccountDetails = ({ height, triggerAction, needHelpAction, goBackAction, profileName, mobileNumber, emailId, panNumber, bankImageUri, bankName, ifscCode, bankAccountNumber, contactUsDetails, editAction, action, otpAction, caption, errorModal, otpModal, showUsersEditIcon, handleCloseModalAction, state = InputStateToken.DEFAULT, setUpModal, closureModal, userUpdatedValue, userUpdatedType, isUserUpdateDetailsInProgress, modalHeight, handleCloseOtpModalAction, errorMessage, otpErrorModal, }) => {
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const [showAccountModal, setShowAccountModal] = useState(false);
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [showClosureModal, setShowClosureModal] = useState(false);
    const [showMobileLoader, setShowMobileLoader] = useState(false);
    const [showEmailLoader, setShowEmailLoader] = useState(false);
    const [currentType, setCurrentType] = useState(UPDATE_REQUEST_TYPE.PHONE_NUMBER);
    const [currentModalHeight, setCurrentModalheight] = useState(0);
    const [showOtpErrorModal, setShowOtpErrorModal] = useState(false);
    const handleCloseModal = async () => {
        await triggerAction(handleCloseModalAction);
    };
    const handleNeedHelp = () => {
        setShowNeedHelp(true);
    };
    useEffect(() => {
        setShowOtpModal(otpModal);
        setShowErrorModal(errorModal);
        setShowClosureModal(closureModal);
        setShowAccountModal(setUpModal);
        setShowOtpErrorModal(otpErrorModal);
    }, [errorModal, otpModal, setUpModal, closureModal, otpErrorModal]);
    useEffect(() => {
        setCurrentModalheight(modalHeight);
    }, [modalHeight]);
    const header = () => {
        return (React.createElement(CustomHeader, { title: "Account details", triggerAction: triggerAction, needHelpAction: handleNeedHelp, goBackAction: goBackAction, showNeedHelpNewArch: true, 
            //@ts-ignore
            skipAndroidExit: true }));
    };
    const errorModalContentPresenter = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.SystemError })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center, label: "Verification failed!" })),
            React.createElement(View, { style: { marginTop: 2 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center, label: errorMessage })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Retry', onPress: handleCloseModal, isDisabled: false }))));
    };
    const setUpModalScreen = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_INFO_DLS, size: IconSizeTokens.XXXXXXL })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center, label: "Account set up in-progress" })),
            React.createElement(View, { style: { padding: 16, backgroundColor: '#F1F3F5', borderRadius: 8, marginTop: 8 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: errorMessage, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Got it', onPress: handleCloseModal, isDisabled: false }))));
    };
    const closureModalScreen = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_INFO_DLS, size: IconSizeTokens.XXXXXXL })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center, label: "Account closure in progress" })),
            React.createElement(View, { style: { padding: 16, backgroundColor: '#F1F3F5', borderRadius: 8, marginTop: 8 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: errorMessage, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Got it', onPress: handleCloseModal, isDisabled: false }))));
    };
    const renderOtpErrorModalBody = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_INFO_REDBG_DLS, size: IconSizeTokens.XXXXXXL, color: ColorTokens.System_Warning })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center, label: "OTP Attempts Exceeded" })),
            React.createElement(View, { style: { padding: 16, backgroundColor: '#F1F3F5', borderRadius: 8, marginTop: 8 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: errorMessage, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: "Ok, got it!", onPress: handleCloseModal, isDisabled: false }))));
    };
    const modalContentPresenter = () => {
        if (showErrorModal) {
            return errorModalContentPresenter();
        }
        else if (showAccountModal) {
            return setUpModalScreen();
        }
        else if (showClosureModal) {
            return closureModalScreen();
        }
        else if (showOtpErrorModal) {
            return renderOtpErrorModalBody();
        }
    };
    const footerChild = () => {
        return (showAccountModal || showErrorModal || showClosureModal || showOtpErrorModal) ? (React.createElement(View, { style: {
                position: 'absolute',
                bottom: 0,
                zIndex: 99
            } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: currentModalHeight, width: '100%', closeFunction: handleCloseModal, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: false, explicitMarginBottom: 0 }, modalContentPresenter()))) : React.createElement(React.Fragment, null);
    };
    const body = () => {
        return (React.createElement(View, { style: { paddingHorizontal: 16, paddingBottom: 16 } },
            React.createElement(ListItem, { title: "Name", subTitle: profileName, onPress: () => {
                }, isDivider: true, titleLineHeight: 18, subTitleLineHeight: 24, leadIconName: IconTokens.Account_profile }),
            React.createElement(ListItem, { title: "Mobile number", subTitle: mobileNumber, onPress: async () => {
                    if (showUsersEditIcon && !isUserUpdateDetailsInProgress && !showMobileLoader) {
                        setShowMobileLoader(true);
                        setCurrentType(UPDATE_REQUEST_TYPE.PHONE_NUMBER);
                        await triggerAction({
                            ...editAction,
                            payload: {
                                ...editAction.payload,
                                requestType: UPDATE_REQUEST_TYPE.PHONE_NUMBER,
                            },
                        });
                        setShowMobileLoader(false);
                    }
                }, isDivider: true, titleLineHeight: 18, subTitleLineHeight: 24, leadIconName: IconTokens.Phone, loader: showMobileLoader, trailIconName: (showMobileLoader || !showUsersEditIcon || isUserUpdateDetailsInProgress) ? null : IconTokens.Edit, userUpdatedValue: userUpdatedValue, userUpdatedType: userUpdatedType, userUpdatedMessage: userUpdatedType === UPDATE_REQUEST_TYPE.PHONE_NUMBER ? true : false, isUserUpdateDetailsInProgress: isUserUpdateDetailsInProgress, shouldCardClickable: false }),
            React.createElement(ListItem, { title: "Email ID", subTitle: emailId, onPress: async () => {
                    setShowEmailLoader(true);
                    setCurrentType(UPDATE_REQUEST_TYPE.EMAIL);
                    if (showUsersEditIcon && !isUserUpdateDetailsInProgress && !showEmailLoader) {
                        await triggerAction({
                            ...editAction,
                            payload: {
                                ...editAction.payload,
                                requestType: UPDATE_REQUEST_TYPE.EMAIL,
                            },
                        });
                    }
                    setShowEmailLoader(false);
                }, isDivider: true, titleLineHeight: 18, subTitleLineHeight: 24, leadIconName: IconTokens.Email, loader: showEmailLoader, trailIconName: (showEmailLoader || !showUsersEditIcon || isUserUpdateDetailsInProgress) ? null : IconTokens.Edit, userUpdatedValue: userUpdatedValue, userUpdatedType: userUpdatedType, userUpdatedMessage: userUpdatedType === UPDATE_REQUEST_TYPE.EMAIL ? true : false, isUserUpdateDetailsInProgress: isUserUpdateDetailsInProgress, shouldCardClickable: false }),
            React.createElement(ListItem, { title: "PAN number", subTitle: panNumber, handleAsterisk: true, onPress: () => {
                }, isDivider: true, titleLineHeight: 18, subTitleLineHeight: 24, leadIconName: IconTokens.CreditCard }),
            React.createElement(View, { style: { marginTop: 40 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "Bank details", color: ColorTokens.Grey_Charcoal }),
                React.createElement(View, { style: { marginTop: 2 } },
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            marginBottom: 8,
                            alignContent: 'center',
                            alignItems: 'center',
                            marginVertical: 16
                        } },
                        React.createElement(Image, { source: { uri: bankImageUri }, style: { width: 40, height: 40, marginRight: 8 } }),
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0B, label: bankName, color: ColorTokens.Grey_Night }))),
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk }),
                React.createElement(View, null,
                    React.createElement(ListItem, { title: "IFSC", subTitle: ifscCode, onPress: () => {
                        }, isDivider: true, titleLineHeight: 18, subTitleLineHeight: 24 }),
                    React.createElement(ListItem, { title: "Account number", subTitle: bankAccountNumber, onPress: () => {
                        }, isDivider: false, titleLineHeight: 18, subTitleLineHeight: 24 })))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(BoilerPlate, { height: height, headerChild: header(), heightHeader: Platform.OS === 'ios' ? 93 : 57, bottomChildren: React.createElement(React.Fragment, null,
                footerChild(),
                showNeedHelp && React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails }),
                showOtpModal &&
                    React.createElement(OtpModalScreenDc, { showOtpModal: showOtpModal, setShowOtpModal: setShowOtpModal, caption: caption, state: state, title: 'Verify your account', subTitle: 'OTP sent to', value: mobileNumber, iconUrl: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/icon_holder_msg.png', action: async (text) => {
                            await triggerAction({
                                ...action,
                                payload: {
                                    ...action.payload,
                                    otp: text,
                                    requestType: currentType,
                                },
                            });
                        }, otpAction: async () => {
                            await triggerAction({
                                ...otpAction,
                                payload: {
                                    ...action.payload,
                                },
                            });
                        }, handleCloseOtpModal: async () => {
                            await triggerAction(handleCloseOtpModalAction);
                        }, triggerAction: triggerAction })) }, body())));
};
export default AccountDetails;
